import {RootState} from '../store';
import { ScalperStateType } from '../reducer/scalper.reducer';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { UserStateType } from '../reducer/user.reducer';
import { DashboardNamespace, Platform } from '../proto/generated/user-preference';

const scalperState = (state: RootState) => state.scalperStore as ScalperStateType

export const selectScalperTradeOptions = (store: RootState) => scalperState(store)?.tradeOptions;

export const selectScalperDashboardConfig = (store: RootState) => scalperState(store).layout;

export const selectPredefinedLayout = (store: RootState) => scalperState(store)?.predefinedLayout;
export const selectScalperLayout = (store: RootState) => scalperState(store)?.scalperLayout;
export const selectScalperInitSecurity = (store: RootState) => scalperState(store)?.initSecurity;

const userState = (state: RootState) => state.userStore as UserStateType

export const selectScalperDashboard = (platform: Platform) => createDraftSafeSelector(userState, (store: UserStateType, ) => {
    if (!store.userDashboards || store.userDashboards.length == 0) return;
        const scalperDashboards = (store.userDashboards || []).filter(dashboard => dashboard.namespace === DashboardNamespace.SCALPER && dashboard.platform === platform);
        return scalperDashboards.length > 0 ? scalperDashboards[0] : null;
    }
);
